
// import base64js from 'base64-js'

// import { ConfiguratorState } from '../components/Configurator';
import {
    getExamResult
} from "./ExamServerMocking"

export interface Execution{
    id:string
    time:number
    name:string
    started:boolean
    finished:boolean
    classroom:Classroom
    examination:Examination
}

export interface Classroom{
    id:string
    name:string
    password:string
}

export interface Examination{
    id:string
    time:number
    name:string
    exercises:Array<Exercise>
}

export interface Exercise{
    id:string
    key:string
    name:string
    description:string
    type: ExerciseType
    tasks: Array<ExerciseTask>
}

export enum ExerciseType {
    Multi = 0,
    Check = 1
}

export interface ExerciseTask{
    id:string
    key:string
    content:string
    tier:number
    options:Array<TaskOption>
}

export interface TaskOption{
    id:string
    key:string
    content:string
    content2?:string
    checked?:boolean
    expected?:boolean
}


export interface Session{
    roomId:string
    executionId:number
    executionStarted:boolean
    executionFinished:boolean
}




class ExamServer {

    //host:string = "http://localhost:8080"
    host:string = ""

    getExams():Promise<Array<Execution>>{

        return new Promise<Array<Execution>>((resolve, reject) => {

            // resolve(getExamResult)

            fetch(this.host + "/api/teacherdesk/exams", {
                //redirect:"manual",
                //mode:"no-cors",
                // body:JSON.stringify({
                //     "id":2
                // }),
                headers:[
                    ["Content-Type","application/json"]
                ],
                method:"GET"
            }).then(response => {
                return response.json()
              }).then(json => {
                resolve(json)
              }).catch(()=>{
                reject()
              })
        });    
    }

    getExamResult(id:string):Promise<Execution>{

        return new Promise<Execution>((resolve, reject) => {

            // resolve(getExamResult)

            fetch(this.host + "/api/teacherdesk/exams/"+id, {
                //redirect:"manual",
                //mode:"no-cors",
                // body:JSON.stringify({
                //     "id":2
                // }),
                headers:[
                    ["Content-Type","application/json"]
                ],
                method:"GET"
            }).then(response => {
                return response.json()
              }).then(json => {
                resolve(json)
              }).catch(()=>{
                reject()
              })
        });    
    }
    archiveExam(id:string):Promise<Execution>{

        return new Promise<Execution>((resolve, reject) => {

            // resolve(getExamResult)
            fetch(this.host + "/api/teacherdesk/exams/"+ id + "/archive", {
                //redirect:"manual",
                //mode:"no-cors",
                // body:JSON.stringify({
                //     "id":id,
                //     "password":password,
                //     "name":name
                // }),
                headers:[
                    ["Content-Type","application/json"]
                ],
                method:"POST"
            }).then(response => {
                return response.json()
              }).then(json => {
                resolve(json)
              }).catch(()=>{
                reject()
              })
        });    
    }

    getClassrooms():Promise<Array<Classroom>>{

        return new Promise<Array<Classroom>>((resolve, reject) => {

            // resolve(getExamResult)

            fetch(this.host + "/api/teacherdesk/classes", {
                //redirect:"manual",
                //mode:"no-cors",
                // body:JSON.stringify({
                //     "id":2
                // }),
                headers:[
                    ["Content-Type","application/json"]
                ],
                method:"GET"
            }).then(response => {
                return response.json()
              }).then(json => {
                resolve(json)
              }).catch(()=>{
                reject()
              })
        });    
    }
    editClassroom(id:string, name:string, password:string):Promise<Classroom>{

        return new Promise<Classroom>((resolve, reject) => {

            // resolve(getExamResult)

            fetch(this.host + "/api/teacherdesk/classes/edit", {
                //redirect:"manual",
                //mode:"no-cors",
                body:JSON.stringify({
                    "id":id,
                    "password":password,
                    "name":name
                }),
                headers:[
                    ["Content-Type","application/json"]
                ],
                method:"POST"
            }).then(response => {
                return response.json()
              }).then(json => {
                resolve(json)
              }).catch(()=>{
                reject()
              })
        });    
    }

    addClassroom(name:string, password:string):Promise<Classroom>{

        return new Promise<Classroom>((resolve, reject) => {

            // resolve(getExamResult)

            fetch(this.host + "/api/teacherdesk/classes/edit", {
                //redirect:"manual",
                //mode:"no-cors",
                body:JSON.stringify({
                    "name":name,
                    "password":password
                }),
                headers:[
                    ["Content-Type","application/json"]
                ],
                method:"POST",
            }).then(response => {
                return response.json()
              }).then(json => {
                resolve(json)
              }).catch(()=>{
                reject()
              })
        });    
    }
    
    login(user?:string, password?:string):Promise<boolean>{

        return new Promise<boolean>((resolve, reject) => {

            // resolve(getExamResult)

            fetch(this.host + "/api/teacherdesk/login", {
                //redirect:"manual",
                //mode:"no-cors",
                body:(user && password)?JSON.stringify({
                    "user":user,
                    "pwd":password
                }):"{}",
                headers:[
                    ["Content-Type","application/json"]
                ],
                method:"POST",
                credentials: 'include'
            }).then(response => {
                return response.json()
              }).then(json => {
                resolve(json.successful)
              }).catch(()=>{
                reject()
              })
        });    
    }



    // Student Desk
    getSession():Promise<Session>{

        return new Promise<Session>((resolve, reject) => {

            // resolve(getExamResult)

            fetch(this.host + "/api/studentdesk", {
                //redirect:"manual",
                mode:"no-cors",
                // body:JSON.stringify({
                //     "id":2
                // }),
                headers:[
                    ["Content-Type","application/json"]
                ],
                method:"GET",
                credentials: 'include'
            }).then(response => {
                return response.json()
              }).then(json => {
                resolve(json.session)
              }).catch(()=>{
                reject()
              })
        });    
    }

    enterClassRoom(activationCode:string):Promise<boolean>{

        return new Promise<boolean>((resolve, reject) => {

            // resolve(getExamResult)

            fetch(this.host + "/api/studentdesk/room/enter", {
                //redirect:"manual",
                //mode:"no-cors",
                body:JSON.stringify({
                    "activationCode":activationCode
                }),
                headers:[
                    ["Content-Type","application/json"]
                ],
                method:"POST",
                credentials: 'include'
            }).then(response => {
                return response.json()
              }).then(json => {
                resolve(json.successful)
              }).catch(()=>{
                reject()
              })
        });    
    }
    
    startExam(name:string):Promise<Execution>{

        return new Promise<Execution>((resolve, reject) => {

            // resolve(getExamResult)

            fetch(this.host + "/api/studentdesk/exam/start", {
                //redirect:"manual",
                //mode:"no-cors",
                body:JSON.stringify({
                    "name":name
                }),
                headers:[
                    ["Content-Type","application/json"]
                ],
                method:"POST",
                credentials: 'include'
            }).then(response => {
                return response.json()
              }).then(json => {
                resolve(json)
              }).catch(()=>{
                reject()
              })
        });    
    }

    finishExam():Promise<Execution>{

        return new Promise<Execution>((resolve, reject) => {

            // resolve(getExamResult)

            fetch(this.host + "/api/studentdesk/exam/finish", {
                //redirect:"manual",
                //mode:"no-cors",
                // body:JSON.stringify({
                //     "name":name
                // }),
                headers:[
                    ["Content-Type","application/json"]
                ],
                method:"POST",
                credentials: 'include'
            }).then(response => {
                return response.json()
              }).then(json => {
                resolve(json)
              }).catch(()=>{
                reject()
              })
        });    
    }

    getExam():Promise<Execution>{

        return new Promise<Execution>((resolve, reject) => {

            // resolve(getExamResult)

            fetch(this.host + "/api/studentdesk/exam", {
                //redirect:"manual",
                //mode:"no-cors",
                // body:JSON.stringify({
                //     "id":2
                // }),
                headers:[
                    ["Content-Type","application/json"]
                ],
                method:"GET"
            }).then(response => {
                return response.json()
              }).then(json => {
                resolve(json)
              }).catch(()=>{
                reject()
              })
        });    
    }

    

    choice(exercise:string, task:string, option:string, checked:boolean):Promise<any>{

        return new Promise<any>((resolve, reject) => {

            // resolve(getExamResult)

            fetch(this.host + "/api/studentdesk/exam/choice", {
                //redirect:"manual",
                //mode:"no-cors",
                body:JSON.stringify({
                    "exercise":exercise,
                    "task":task,
                    "option":option,
                    "checked":checked
                }),
                headers:[
                    ["Content-Type","application/json"]
                ],
                method:"POST"
            }).then(response => {
                return response.json()
              }).then(json => {
                resolve(json)
              }).catch(()=>{
                reject()
              })
        });    
    }



	
}

export default ExamServer;
